<template>
    <div class="kuan-wrapper">
        <div class="chart-item">
            <p>应收账款</p>
            <div class="total-wrapper">
                <div class="total-item">
                    本月实收(万元)：<span>{{ ysTotal.byss }}</span>
                </div>
                <div class="total-item">
                    本年累计(万元)：<span>{{ ysTotal.bnss }}</span>
                </div>
            </div>
            <div id="ysChart" class="chart-wrapper ysChart"></div>
        </div>
        <div class="chart-item">
            <p>应付账款</p>
            <div class="total-wrapper">
                <div class="total-item">
                    本月实付(万元)：<span>{{ yfTotal.bysf }}</span>
                </div>
                <div class="total-item">
                    本年累计(万元)：<span>{{ yfTotal.bnsf }}</span>
                </div>
            </div>
            <div id="yfChart" class="chart-wrapper yfChart"></div>
        </div>
    </div>
</template>

<script>
import bg_blue from '../../../assets/images/home/bg_blue.png';
import bg_orange from '../../../assets/images/home/bg_orange.png';
import bg_green from '../../../assets/images/home/bg_green.png';
import bg_yellow from '../../../assets/images/home/bg_yellow.png';
import { Toast } from 'vant';

export default {
    data() {
        return {
            ysData: [],
            ysTotal: {},
            yfData: [],
            yfTotal: {},
            Year: '',
            Month: '',
        };
    },
    created() {
        this.Year = new Date().getFullYear();
        this.Month = new Date().getMonth() + 1;
    },
    mounted() {
        this.getReceivableStatistics(); // 获取应收统计
        this.getReceivableTotal(); // 获取应收统计字段
        this.getPayableStatistics(); // 获取应付统计
        this.getPayableTotal(); // 获取应付统计字段
    },
    methods: {
        // 获取应收统计
        getReceivableStatistics() {
            this.$axios
                .get('/interfaceApi/report/largescreen/yszk/' + this.Year + '/' + this.Month)
                .then(res => {
                    this.ysData = res;
                    this.ysChart();
                })
                .catch(error => {
                    Toast.fail('message:' + error.ErrorCode.Message + '');
                });
        },
        getReceivableTotal() {
            this.$axios
                .get('/interfaceApi/report/largescreen/yszk/tj/' + this.Year + '/' + this.Month)
                .then(res => {
                    this.ysTotal = res;
                })
                .catch(error => {
                    Toast.fail('message:' + error.ErrorCode.Message + '');
                });
        },
        // 获取应付统计
        getPayableStatistics() {
            this.$axios
                .get('/interfaceApi/report/largescreen/yfzk/' + this.Year + '/' + this.Month)
                .then(res => {
                    this.yfData = res;
                    this.yfChart();
                })
                .catch(error => {
                    Toast.fail('message:' + error.ErrorCode.Message + '');
                });
        },
        getPayableTotal() {
            this.$axios
                .get('/interfaceApi/report/largescreen/yfzk/tj/' + this.Year + '/' + this.Month)
                .then(res => {
                    this.yfTotal = res;
                })
                .catch(error => {
                    Toast.fail('message:' + error.ErrorCode.Message + '');
                });
        },
        ysChart() {
            const myChart = this.$echarts.init(document.getElementById('ysChart'));
            const xdata = [];
            const data1 = [];
            const data2 = [];

            this.ysData.forEach(item => {
                xdata.push(item.ysyf + '月');
                data1.push(item.ysqc);
                data2.push(item.ysqm);
            });

            const option = {
                grid: {
                    left: '10%',
                    top: '16%',
                    bottom: '12%',
                    right: '0%',
                },
                tooltip: {
                    trigger: 'axis',
                    // formatter: '{b}{a} : {c}',
                    formatter: function (params) {
                        let str = '';
                        for (let i = 0; i < params.length; i++) {
                            if (params[i].seriesName !== '') {
                                str
                        += params[i].name
                        + ':'
                        + params[i].seriesName
                        + params[i].value
                        + '<br/>';
                            }
                        }
                        return str;
                    },
                },
                legend: {
                    left: 'right',
                    selectedMode: false,
                    top: '0',
                    textStyle: {
                        color: '#ccc',
                    },
                    icon: 'rect',
                },
                xAxis: {
                    data: xdata,
                    axisPointer: {
                        // type: 'shadow',
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#D7D7D7',
                            width: 1, // 这里是为了突出显示加上的
                        },
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#999',
                            fontSize: 10,
                        },
                    },
                },
                yAxis: [{
                    splitNumber: 6,
                    name: '万元',
                    nameTextStyle: {
                        align: 'right',
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#D7D7D7',
                            width: 1, // 这里是为了突出显示加上的
                        },
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#999',
                        },
                    },
                    splitArea: {
                        areaStyle: {
                            color: 'rgba(255,255,255,.5)',
                        },
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#ccc',
                            width: 1,
                            type: 'dashed',
                        },
                    },
                },
                ],
                series: [{
                    name: '应收期初',
                    type: 'bar',
                    label: {
                        show: true,
                        position: 'top',
                        distance: 0,
                        color: '#55a7fe',
                        fontWeight: 'bolder',
                        fontSize: 12,
                        formatter: '{c}',
                        width: 18,
                        height: 22,
                        align: 'center',
                        lineHeight: 22,
                        padding: [0, 4, 4, 4],
                        backgroundColor: {
                            image: bg_blue,
                        },
                    },
                    barWidth: 10,
                    itemStyle: {
                        normal: {
                            show: true,
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [{
                                    offset: 0,
                                    color: '#55a7fe', //  0%  处的颜色
                                },
                                {
                                    offset: 1,
                                    color: '#3e79c5', //  100%  处的颜色
                                },
                                ],
                                global: false, //  缺省为  false
                            },
                        },
                        emphasis: {
                            opacity: 1,
                        },
                    },
                    data: data1,
                    z: 10,
                },
                {
                    name: '应收期末',
                    type: 'bar',
                    label: {
                        show: true,
                        position: 'top',
                        distance: 0,
                        color: '#F98F48',
                        fontWeight: 'bolder',
                        fontSize: 12,
                        formatter: '{c}',
                        width: 18,
                        height: 22,
                        align: 'center',
                        lineHeight: 22,
                        padding: [0, 4, 4, 4],
                        backgroundColor: {
                            image: bg_orange,
                        },
                    },
                    barWidth: 10,
                    itemStyle: {
                        normal: {
                            show: true,
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [{
                                    offset: 0,
                                    color: '#EFAB54', //  0%  处的颜色
                                },
                                {
                                    offset: 1,
                                    color: '#FA8C47', //  100%  处的颜色
                                },
                                ],
                                global: false, //  缺省为  false
                            },
                        },
                        emphasis: {
                            opacity: 1,
                        },
                    },
                    data: data2,
                    z: 10,
                }],
            };
            myChart.setOption(option);
        },
        yfChart() {
            const myChart = this.$echarts.init(document.getElementById('yfChart'));
            const xdata = [];
            const data1 = [];
            const data2 = [];

            this.yfData.forEach(item => {
                xdata.push(item.yfyf + '月');
                data1.push(item.yfqc);
                data2.push(item.yfqm);
            });
            const option = {
                grid: {
                    left: '10%',
                    top: '16%',
                    bottom: '12%',
                    right: '0%',
                },
                tooltip: {
                    trigger: 'axis',
                    // formatter: '{b}{a} : {c}',
                    formatter: function (params) {
                        let str = '';
                        for (let i = 0; i < params.length; i++) {
                            if (params[i].seriesName !== '') {
                                str
                        += params[i].name
                        + ':'
                        + params[i].seriesName
                        + params[i].value
                        + '<br/>';
                            }
                        }
                        return str;
                    },
                },
                legend: {
                    left: 'right',
                    selectedMode: false,
                    top: '0',
                    textStyle: {
                        color: '#ccc',
                    },
                    icon: 'rect',
                },
                xAxis: {
                    data: xdata,
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#D7D7D7',
                            width: 1, // 这里是为了突出显示加上的
                        },
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#999',
                            fontSize: 10,
                        },
                    },
                },
                yAxis: [{
                    splitNumber: 6,
                    name: '万元',
                    nameTextStyle: {
                        align: 'right',
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#D7D7D7',
                            width: 1, // 这里是为了突出显示加上的
                        },
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#999',
                        },
                    },
                    splitArea: {
                        areaStyle: {
                            color: 'rgba(255,255,255,.5)',
                        },
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#ccc',
                            width: 1,
                            type: 'dashed',
                        },
                    },
                },
                ],
                series: [{
                    name: '应付期初',
                    type: 'bar',
                    label: {
                        show: true,
                        position: 'top',
                        distance: 0,
                        color: '#71C6B0',
                        fontWeight: 'bolder',
                        fontSize: 12,
                        formatter: '{c}',
                        width: 18,
                        height: 22,
                        align: 'center',
                        lineHeight: 22,
                        padding: [0, 4, 4, 4],
                        backgroundColor: {
                            image: bg_green,
                        },
                    },
                    barWidth: 10,
                    itemStyle: {
                        normal: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [{
                                    offset: 0,
                                    color: 'rgba(113,198,176,1)', //  0%  处的颜色
                                },
                                {
                                    offset: 1,
                                    color: 'rgba(78,164,150,1)', //  100%  处的颜色
                                },
                                ],
                                global: false, //  缺省为  false
                            },
                        },
                        emphasis: {
                            opacity: 1,
                        },
                    },
                    data: data1,
                    z: 10,
                },
                {
                    name: '应付期末',
                    type: 'bar',
                    label: {
                        show: true,
                        position: 'top',
                        distance: 0,
                        color: '#F2E341',
                        fontWeight: 'bolder',
                        fontSize: 12,
                        formatter: '{c}',
                        width: 18,
                        height: 22,
                        align: 'center',
                        lineHeight: 22,
                        padding: [0, 4, 4, 4],
                        backgroundColor: {
                            image: bg_yellow,
                        },
                    },
                    barWidth: 10,
                    itemStyle: {
                        normal: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [{
                                    offset: 0,
                                    color: 'rgba(242,227,65,1)', //  0%  处的颜色
                                },
                                {
                                    offset: 1,
                                    color: 'rgba(220,193,41,1)', //  100%  处的颜色
                                },
                                ],
                                global: false, //  缺省为  false
                            },
                        },
                        emphasis: {
                            opacity: 1,
                        },
                    },
                    data: data2,
                    z: 10,
                }],
            };
            myChart.setOption(option);
        },
    },
};
</script>

<style lang="stylus">
    .kuan-wrapper
        // margin-top 20rpx
        .chart-item
            padding 15rpx
            background #ffffff
            &:last-child
                margin-top 15rpx
            p
                font-size 16rpx
                font-weight 600
                color rgba(51,51,51,1)
                line-height 36px
            .total-wrapper
                display flex
                justify-content space-between
                .total-item
                    width 150rpx
                    height 30rpx
                    border 2rpx solid rgba(234,234,234,1)
                    font-size 10rpx
                    line-height 26rpx
                    text-align center
                    span
                        font-size 14rpx
                        line-height 26rpx
                    &:first-child
                        span
                            color #4486D5
                    &:last-child
                        span
                            color #F8924A
            .chart-wrapper
                height 240rpx
                width 100%


</style>